import { ReactNode, useState } from 'react';
import { IncidentStatusOption } from '@/graphql/generated';
import { UpdateStatusWithNoteModalContext } from './UpdateStatusWithNoteModalContext';

type UpdateStatusWithNoteModalContextProviderProps = {
  children: ReactNode;
};

export const UpdateStatusWithNoteModalContextProvider = ({ children }: UpdateStatusWithNoteModalContextProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState<IncidentStatusOption | null>(null);
  const [initialNote, setInitialNote] = useState<string | undefined>(undefined);
  const [onConfirm, setOnConfirm] = useState<(() => void) | undefined>(undefined);

  const openModal = ({ 
    status, 
    initialNote, 
    onConfirm 
  }: { 
    status: IncidentStatusOption; 
    initialNote?: string; 
    onConfirm?: () => void 
  }) => {
    setStatus(status);
    setInitialNote(initialNote);
    setOnConfirm(() => onConfirm);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setStatus(null);
    setInitialNote(undefined);
    setOnConfirm(undefined);
  };

  return (
    <UpdateStatusWithNoteModalContext.Provider value={{ 
      isOpen, 
      status, 
      initialNote, 
      onConfirm, 
      openModal, 
      closeModal 
    }}>
      {children}
    </UpdateStatusWithNoteModalContext.Provider>
  );
};
